var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUpload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 36,
  fill: "none",
  viewBox: "0 0 20 21"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M.91 12.729a.91.91 0 0 0-.91.909v2.727A3.636 3.636 0 0 0 3.636 20h12.728A3.636 3.636 0 0 0 20 16.365v-2.727a.909.909 0 1 0-1.818 0v2.727a1.82 1.82 0 0 1-1.818 1.818H3.636a1.82 1.82 0 0 1-1.818-1.818v-2.727a.91.91 0 0 0-.91-.91z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M9.997 15.299a.91.91 0 0 0 .909-.91V3.04l2.098 2.007a.91.91 0 1 0 1.258-1.313L10.627.253a.91.91 0 0 0-1.259 0l-3.636 3.48a.91.91 0 0 0-.028 1.286.91.91 0 0 0 1.287.027L9.088 3.04v11.35a.91.91 0 0 0 .909.909"
})));
export default SvgUpload;